









































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Fournisseur} from '@/models';
import CrudAddressEdit from '@/components/Crud/Address/Edit.vue';

import storeFournisseur from '@/stores/modules/fournisseur';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
		CrudAddressEdit,
	}
})
export default class CrudFournisseurEdit extends AbstractEditVue<Fournisseur> {

	// DF: utiliser pour la création d'un fournisseur uniquement
	// en modification on passe par la light
	private step: number = 1;

	public constructor() {
		super(
			storeFournisseur,
			'Fournisseur modifié',
			'Fournisseur créé',
		);
	}

	@Emit()
	private onNext() {
		if ((!this.item.address) || (this.item.address === null) )
		{
			this.item.address = this.item.name;
		}
		this.step = 2;
	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		//console.log('route fournisseur edit = ' + this.$route.name);
		if (this.$route.name === 'fournisseur-edit') {
			this.$route.meta.title = 'Modification  d\'un fournisseur';
		}
	}

}
